module.exports = "<div class=\"not-found\">\n  <p>Page Not Found</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/not-found/not-found.component.html
// module id = ../../../../../src/app/shared/components/not-found/not-found.component.html
// module chunks = main